import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['mobileMenu', 'mobileMenuCloseBtn', 'link']

  connect() {
    this.navBreakpoint = 800
  }

  closeMobileMenu(event) {
    const insideNav = this.element.contains(event.target)
    const onCloseBtn = this.mobileMenuCloseBtnTarget.contains(event.target)
    const onLink = this.linkTargets.some((link) => link.contains(event.target))

    if (
      (insideNav && !onCloseBtn && !onLink) ||
      window.innerWidth >= this.navBreakpoint ||
      !this.element.classList.contains('active')
    ) return

    this.element.classList.remove('active')
  }

  openMobileMenu() {
    if (this.element.classList.contains('active')) return

    this.element.classList.add('active')
  }

  setMenuPosition() {
    if (window.innerWidth >= this.navBreakpoint) {
      this.element.classList.remove('active')
    }
  }
}
